import React, { useMemo, useState } from 'react';
import {
  AdminPageHeader,
  AdminTableWrap,
  AdminDevRowMeta,
  AdminDevTh,
  btnLink,
  btnPrimary,
  filtersRowClass,
  inputClass,
  selectClass,
  tdClass,
} from '../adminUi';
import { useGrading } from './GradingContext';
import { GradingDeleteButton, GradingScoreRange } from './GradingShared';
import { confirmAndRunDelete, formatPath, resolveRolePath } from './utils';
import { deleteGradingRole } from '../../../../services/gradingService';

export default function GradingRolesTab() {
  const { families, roleClusters, specializations, roles, questions, openDrawer, reload } = useGrading();
  const [search, setSearch] = useState('');
  const [familyFilter, setFamilyFilter] = useState('');
  const [roleClusterFilter, setRoleClusterFilter] = useState('');

  const rows = useMemo(() => {
    return roles.map((r) => {
      const { family, roleCluster, spec } = resolveRolePath(r, specializations, roleClusters, families);
      const qCount = questions.filter((q) => q.role_cluster_id === r.role_cluster_id).length;
      return {
        r,
        spec,
        rc: roleCluster,
        family,
        qCount,
        path: formatPath([family?.name, roleCluster?.name, r.name]),
      };
    }).filter(({ r, family, rc, path }) => {
      const q = search.trim().toLowerCase();
      if (q && !r.name.toLowerCase().includes(q) && !String(r.grade_level).includes(q)) return false;
      if (familyFilter && Number(family?.id) !== Number(familyFilter)) return false;
      if (roleClusterFilter && Number(rc?.id) !== Number(roleClusterFilter)) return false;
      return true;
    });
  }, [roles, specializations, roleClusters, families, questions, search, familyFilter, roleClusterFilter]);

  const filteredRoleClusters = roleClusters.filter((s) => !familyFilter || Number(s.family_id) === Number(familyFilter));

  return (
    <div>
      <AdminPageHeader
        title="Роли и грейды"
        subtitle="Role привязана к Role cluster; Specialization опциональна на уровне Family"
        actions={
          <button type="button" className={btnPrimary} onClick={() => openDrawer({ type: 'role', mode: 'create' })}>
            Добавить Role
          </button>
        }
      />

      <div className={filtersRowClass}>
        <input className={inputClass} placeholder="Поиск по названию роли или грейду" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className={selectClass} value={familyFilter} onChange={(e) => { setFamilyFilter(e.target.value); setRoleClusterFilter(''); }}>
          <option value="">Все Family</option>
          {families.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
        <select className={selectClass} value={roleClusterFilter} onChange={(e) => setRoleClusterFilter(e.target.value)}>
          <option value="">Все Role cluster</option>
          {filteredRoleClusters.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </div>

      <AdminTableWrap>
        <table className="w-full min-w-[1000px] text-sm">
          <thead className="border-b border-slate-100 bg-slate-50/80">
            <tr>
              <AdminDevTh label="Role" dbField="roles.name" />
              <AdminDevTh label="Grade" dbField="roles.grade_level" />
              <AdminDevTh label="Путь" dbField="role_clusters → families" />
              <AdminDevTh label="Specialization" dbField="roles.specialization_id" />
              <AdminDevTh label="Min / Max" dbField="roles.min_score / roles.max_score" />
              <AdminDevTh label="Вопросов role cluster" dbField="questions.role_cluster_id" />
              <AdminDevTh label="Действия" />
            </tr>
          </thead>
          <tbody>
            {rows.map(({ r, spec, path, qCount }) => (
              <tr key={r.id} className="border-b border-slate-50 hover:bg-slate-50/50">
                <td className={tdClass}>
                  <button type="button" className={btnLink} onClick={() => openDrawer({ type: 'role', mode: 'edit', id: r.id })}>
                    {r.name}
                  </button>
                  <AdminDevRowMeta parts={[
                    `roles.id=${r.id}`,
                    `roles.role_cluster_id=${r.role_cluster_id}`,
                    r.specialization_id != null && `roles.specialization_id=${r.specialization_id}`,
                  ]} />
                </td>
                <td className={tdClass}>{r.grade_level}</td>
                <td className={`${tdClass} max-w-xs truncate text-slate-600`} title={path}>{path}</td>
                <td className={tdClass}>{spec?.name || '—'}</td>
                <td className={tdClass}><GradingScoreRange min={r.min_score} max={r.max_score} /></td>
                <td className={tdClass}>{qCount}</td>
                <td className={tdClass}>
                  <div className="flex gap-3">
                    <button type="button" className={btnLink} onClick={() => openDrawer({ type: 'role', mode: 'edit', id: r.id })}>Редактировать</button>
                    <GradingDeleteButton
                      onClick={() => confirmAndRunDelete(
                        r.name,
                        'Role будет удалена без возможности восстановления.',
                        () => deleteGradingRole(r.id),
                        reload,
                      )}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </AdminTableWrap>
    </div>
  );
}
